import headingOne from './heading-one';
import headingTwo from './heading-two';
import headingThree from './heading-three';
import headingFour from './heading-four';
import paragraph from './paragraph';
import link from './link';
import bulletedList from './bulleted-list';
import numberedList from './numbered-list';
import listItem from './list-item';
import softBreak from './soft-break';
import mergeTag from './merge-tag';
import html from './html';
import body from './body';
import container from './container';
import section from './section';
import placeholder from './placeholder';
import row from './row';
import column from './column';
import richText from './rich-text';
import image from './image';
import button from './button';
import divider from './divider';
import spacer from './spacer';
import error from './error';

const blocks = {
    html,
    body,
    container,
    section,
    placeholder,
    row,
    column,
    'rich-text': richText,
    image,
    button,
    divider,
    spacer,
    paragraph: paragraph,
    'heading-one': headingOne,
    'heading-two': headingTwo,
    'heading-three': headingThree,
    'heading-four': headingFour,
    link,
    'bulleted-list': bulletedList,
    'numbered-list': numberedList,
    'list-item': listItem,
    'soft-break': softBreak,
    'merge-tag': mergeTag,
    error,
};

export default blocks;
